import { Routes, Route, Navigate } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Home           from './pages/Home';
import ProductDetail  from './pages/ProductDetail';
import MenuDetail     from './pages/MenuDetail';
import Cart           from './pages/Cart';
import OrderSuccess   from './pages/OrderSuccess';
import AdminLogin    from './pages/AdminLogin';
import AdminLayout   from './components/AdminLayout';

// Informasi
import Dashboard     from './pages/admin/info/Dashboard';
import Customers     from './pages/admin/info/Customers';
import KartuStok    from './pages/admin/info/KartuStok';
import BonusKaryawan from './pages/admin/info/BonusKaryawan';
import Analytics     from './pages/admin/info/Analytics';
import Referral      from './pages/admin/info/Referral';
import Settings      from './pages/admin/info/Settings';
import HariLibur     from './pages/admin/info/HariLibur';

// Transaksi
import KelolaPO      from './pages/admin/transaksi/KelolaPO';
import OrderPO       from './pages/admin/transaksi/OrderPO';
import OrderPOS      from './pages/admin/transaksi/OrderPOS';
import Shift         from './pages/admin/transaksi/Shift';
import KasHarian     from './pages/admin/transaksi/KasHarian';

// Master
import ProdukPO      from './pages/admin/master/ProdukPO';
import MenuPOS       from './pages/admin/master/MenuPOS';
import MenuPaket     from './pages/admin/master/MenuPaket';
import RewardCatalog from './pages/admin/master/RewardCatalog';
import Stok          from './pages/admin/master/Stok';
import Pengguna      from './pages/admin/master/Pengguna';
import Area          from './pages/admin/master/Area';

function PrivateRoute({ children }) {
  return sessionStorage.getItem('sapan_admin') ? children : <Navigate to="/admin/login" replace />;
}

export default function App() {
  return (
    <CartProvider>
    <Routes>
      <Route path="/"            element={<Home />} />
      <Route path="/product/:id" element={<ProductDetail />} />
      <Route path="/menu/:id"    element={<MenuDetail />} />
      <Route path="/cart"        element={<Cart />} />
      <Route path="/order/:id"   element={<OrderSuccess />} />
      <Route path="/admin/login" element={<AdminLogin />} />

      <Route path="/admin" element={<PrivateRoute><AdminLayout /></PrivateRoute>}>
        {/* Informasi */}
        <Route index                  element={<Dashboard />} />
        <Route path="info/customers"  element={<Customers />} />
        <Route path="info/kartu-stok" element={<KartuStok />} />
        <Route path="info/bonus-karyawan" element={<BonusKaryawan />} />
        <Route path="info/analytics"  element={<Analytics />} />
        <Route path="info/referral"   element={<Referral />} />
        <Route path="info/settings"   element={<Settings />} />
        <Route path="info/hari-libur" element={<HariLibur />} />

        {/* Transaksi */}
        <Route path="transaksi/kelola-po" element={<KelolaPO />} />
        <Route path="transaksi/order-po"  element={<OrderPO />} />
        <Route path="transaksi/order-pos" element={<OrderPOS />} />
        <Route path="transaksi/shift"     element={<Shift />} />
        <Route path="transaksi/kas-harian" element={<KasHarian />} />

        {/* Master */}
        <Route path="master/produk-po"      element={<ProdukPO />} />
        <Route path="master/menu-pos"       element={<MenuPOS />} />
        <Route path="master/menu-paket"     element={<MenuPaket />} />
        <Route path="master/reward-catalog" element={<RewardCatalog />} />
        <Route path="master/stok"           element={<Stok />} />
        <Route path="master/pengguna"       element={<Pengguna />} />
        <Route path="master/area"           element={<Area />} />

        {/* Legacy redirects — url lama tidak 404 */}
        <Route path="po"        element={<Navigate to="/admin/transaksi/kelola-po" replace />} />
        <Route path="orders"    element={<Navigate to="/admin/transaksi/order-po"  replace />} />
        <Route path="customers" element={<Navigate to="/admin/info/customers"      replace />} />
        <Route path="area"      element={<Navigate to="/admin/master/area"         replace />} />
        <Route path="product"   element={<Navigate to="/admin/master/produk-po"    replace />} />
      </Route>
    </Routes>
    </CartProvider>
  );
}
